export default {
	editor_background_color: 'Background color',
	editor_default_font_removed: 'Saved default font removed',
	editor_default_font_saved: 'Font and size saved as default',
	editor_remove_default_font: 'Remove the saved default font',
	editor_save_default_font: 'Save current font and size as default',
	editor_text_color: 'Text color',
	mail_attachment_to_document_already_converted: 'Attachment is already in the document storage',
	mail_attachment_to_document_cancel: 'Cancel',
	mail_attachment_to_document_failed: 'Creating the document failed',
	mail_attachment_to_document_no_postboxes: 'No postboxes available',
	mail_attachment_to_document_postbox_label: 'Postbox',
	mail_attachment_to_document_submit: 'Create document',
	mail_attachment_to_document_success: 'Document created',
	mail_attachment_to_document_title: 'Convert attachment to document',
	mail_bcc: 'BCC',
	mail_cc: 'CC',
	mail_compose_attach_files: 'Attach',
	mail_compose_auto_drafts_hidden_hint: '{count} older automatically saved drafts hidden',
	mail_compose_automatic_saved_drafts: 'Automatically saved drafts',
	mail_compose_bcc: 'BCC',
	mail_compose_cc: 'CC',
	mail_compose_cc_bcc: 'CC/BCC',
	mail_compose_delete_attachment_dialog_message_prefix: 'Do you really want to delete the attachment with the name',
	mail_compose_delete_attachment_dialog_message_suffix: '?',
	mail_compose_delete_attachment_dialog_title: 'Delete attachment',
	mail_compose_delete_draft: 'Delete draft',
	mail_compose_delete_draft_dialog_message_prefix: 'Do you really want to delete the draft with the name',
	mail_compose_delete_draft_dialog_message_suffix: '?',
	mail_compose_delete_draft_dialog_title: 'Delete draft',
	mail_compose_delete_draft_notify_message_prefix: 'The draft with the name',
	mail_compose_delete_draft_notify_message_suffix: 'has been deleted',
	mail_compose_delete_template: 'Delete template',
	mail_compose_delete_template_dialog_message_prefix: 'Do you really want to delete the template with the name',
	mail_compose_delete_template_dialog_message_suffix: '?',
	mail_compose_delete_template_dialog_title: 'Delete template',
	mail_compose_delete_template_notify_message_prefix: 'The template with the name',
	mail_compose_delete_template_notify_message_suffix: 'has been deleted',
	mail_compose_dialog_camera: 'Camera',
	mail_compose_dialog_mediathek: 'Media library',
	mail_compose_dialog_select_files: 'Select files',
	mail_compose_dialog_selected_files: 'Selected files',
	mail_compose_dialog_upload_files: 'Upload files',
	mail_compose_dialog_uploading: 'Uploading ....',
	mail_compose_draft_button: 'Draft',
	mail_compose_draft_button_delete: 'Delete draft',
	mail_compose_draft_button_save: 'Save draft',
	mail_compose_drafts_empty: 'No drafts available',
	mail_compose_drop_image_as_attachment: 'As attachment',
	mail_compose_drop_image_dialog_message: 'How would you like to insert the image?',
	mail_compose_drop_image_dialog_title: 'Insert image',
	mail_compose_drop_image_inline: 'Insert inline',
	mail_compose_editor_drop_hint_message: 'Drop an image or file here to start the upload.',
	mail_compose_editor_drop_hint_title: 'Drag into the editor to upload',
	mail_compose_forward_date: 'Date',
	mail_compose_forward_header: 'Forwarded message',
	mail_compose_forward_sender: 'Sender',
	mail_compose_forward_subject: 'Subject',
	mail_compose_global_drafts: 'Global drafts',
	mail_compose_global_templates: 'Global templates',
	mail_compose_ido_persist_failed: 'The email was sent, but the file link could not be saved.',
	mail_compose_inline_image_hint_many: '{count} inline images will be sent',
	mail_compose_inline_image_hint_one: '{count} inline image will be sent',
	mail_compose_managed_signature: 'Signature',
	mail_compose_open_video_link: 'Open video',
	mail_compose_own_drafts: 'Own drafts',
	mail_compose_own_templates: 'Own templates',
	mail_compose_provide_template_name_message: 'Please enter the name of the template',
	mail_compose_provide_template_name_title: 'Save template',
	mail_compose_recipient_search_failed: 'Search failed',
	mail_compose_recipient_search_minimum_input: 'Enter at least 3 characters',
	mail_compose_recipient_search_no_matches: 'No results found',
	mail_compose_recipient_search_running: 'Searching…',
	mail_compose_save_draft: 'Save draft',
	mail_compose_save_draft_notify_message_prefix: 'The draft with the name',
	mail_compose_save_draft_notify_message_suffix: 'has been saved',
	mail_compose_save_template: 'Save template',
	mail_compose_save_template_new_btn: 'Save as new template',
	mail_compose_save_template_notify_message_prefix: 'The draft with the name',
	mail_compose_save_template_notify_message_suffix: 'has been saved',
	mail_compose_save_template_overwrite_btn: 'Overwrite',
	mail_compose_save_template_overwrite_message:
		'Do you want to overwrite the existing template "{name}" or save as a new template?',
	mail_compose_save_template_overwrite_title: 'Save template',
	mail_compose_send: 'Send',
	mail_compose_send_later_dialog_cancel: 'Cancel',
	mail_compose_send_later_dialog_send_later: 'Send later',
	mail_compose_send_later_dialog_send_later_title: 'Send mail later',
	mail_compose_send_unconfirmed:
		'The email send could not be confirmed. Please check the sent folder before sending it again.',
	mail_compose_sender: 'Sender',
	mail_compose_signature_preview_empty: 'No signature available',
	mail_compose_signature_preview_title: 'Signature preview',
	mail_compose_signature_preview_tooltip: 'Signature preview',
	mail_compose_standard_template_hint: 'Standard template for {account}',
	mail_compose_subject: 'Subject',
	mail_compose_template_button: 'Templates',
	mail_compose_template_button_delete: 'Delete template',
	mail_compose_template_button_save: 'Save template',
	mail_compose_templates_empty: 'No templates available',
	mail_compose_to: 'To',
	mail_compose_upload_failed_prefix: 'Upload failed: ',
	mail_contact_picture_action_label: 'Set contact picture',
	mail_contact_picture_cancel_label: 'Cancel',
	mail_contact_picture_current_alt: 'Current contact picture',
	mail_contact_picture_dialog_title: 'Set contact picture from email',
	mail_contact_picture_drop_hint: 'or drop an image file here',
	mail_contact_picture_google_search_label: 'Google image search',
	mail_contact_picture_invalid_file_error: 'Please choose an image file.',
	mail_contact_picture_loading_preview: 'Loading preview...',
	mail_contact_picture_no_images_message: 'This email contains no usable image attachments.',
	mail_contact_picture_preview_alt: 'Preview of the selected contact picture',
	mail_contact_picture_preview_empty: 'Choose an image attachment or image file.',
	mail_contact_picture_preview_label: 'Preview',
	mail_contact_picture_preview_load_error: 'The image preview could not be loaded.',
	mail_contact_picture_replace_label: 'Choose another image',
	mail_contact_picture_save_error: 'Contact picture could not be saved. Please try again.',
	mail_contact_picture_save_label: 'Save contact picture',
	mail_contact_picture_save_success: 'Contact picture saved.',
	mail_contact_picture_source_email_label: 'Images from this email',
	mail_contact_picture_source_upload_label: 'Choose image',
	mail_contact_picture_target_label: 'Contact',
	mail_copied_to_destination_account_success: 'The email was successfully copied to the destination account',
	mail_date: 'Date',
	mail_delete_dialog_confirm_cancel_label: 'No',
	mail_delete_dialog_confirm_message: 'Do you really want to delete this email?',
	mail_delete_dialog_confirm_ok_label: 'Yes',
	mail_delete_dialog_confirm_title: 'Delete email',
	mail_extended_search_active_tooltip: 'Advanced search active: {count} fields',
	mail_extended_search_apply_label: 'Apply',
	mail_extended_search_cancel_label: 'Cancel',
	mail_extended_search_clear_label: 'Reset',
	mail_extended_search_contact_label: 'Contact',
	mail_extended_search_file_type_label: 'File type',
	mail_extended_search_filename_label: 'File name',
	mail_extended_search_min_length_hint: 'Enter at least 4 characters.',
	mail_extended_search_no_suggestions: 'No suggestions',
	mail_extended_search_open_label: 'Advanced search',
	mail_extended_search_subject_label: 'Subject',
	mail_extended_search_suggestions_error: 'Suggestions could not be loaded.',
	mail_extended_search_text_label: 'Text',
	mail_extended_search_title: 'Email advanced search',
	mail_forward: 'Forward',
	mail_from: 'From',
	mail_invitation_action_accepted: 'Accept',
	mail_invitation_action_declined: 'Decline',
	mail_invitation_action_tentative: 'Tentative',
	mail_invitation_block_title: 'Meeting invitation',
	mail_invitation_respond_failed: 'The meeting response could not be queued for sending.',
	mail_invitation_respond_queued: 'The meeting response is queued for sending.',
	mail_invitation_respond_queued_link_not_stored:
		'The meeting response is queued for sending. The local response status could not be stored.',
	mail_invitation_status_accepted: 'Accepted',
	mail_invitation_status_declined: 'Declined',
	mail_invitation_status_label: 'Your response',
	mail_invitation_status_responded: 'Answered',
	mail_invitation_status_tentative: 'Tentative',
	mail_legacy_back_to_default: 'Back to normal view',
	mail_legacy_download_source: 'Download source',
	mail_legacy_load_failed: 'The view could not be loaded.',
	mail_legacy_loading_source: 'Loading source...',
	mail_legacy_loading_unprocessed: 'Loading unprocessed view...',
	mail_legacy_show_source: 'Show source',
	mail_legacy_show_unprocessed: 'Email not readable?',
	mail_legacy_source_badge: 'Source',
	mail_legacy_source_unavailable: 'The source of this email is not available.',
	mail_legacy_unprocessed_badge: 'Original',
	mail_legacy_unprocessed_unavailable: 'The unprocessed view is not available for this email.',
	mail_print: 'Print',
	mail_print_attachments: 'Attachments',
	mail_receiver_groups_add_members_button: 'Add addresses',
	mail_receiver_groups_add_members_failed: 'Addresses could not be added.',
	mail_receiver_groups_add_members_hint:
		'Search an email address or paste multiple addresses separated by semicolons, commas, spaces, or line breaks.',
	mail_receiver_groups_add_members_label: 'Search email address',
	mail_receiver_groups_add_members_success: 'Addresses were added.',
	mail_receiver_groups_caption: 'Manage recipient groups for mail compose.',
	mail_receiver_groups_create_button: 'Create group',
	mail_receiver_groups_create_failed: 'Recipient group could not be created.',
	mail_receiver_groups_create_name_label: 'Group name',
	mail_receiver_groups_create_success: 'Recipient group created.',
	mail_receiver_groups_delete_confirm_accept: 'Delete',
	mail_receiver_groups_delete_confirm_message: 'Do you really want to delete this recipient group?',
	mail_receiver_groups_delete_confirm_reject: 'Cancel',
	mail_receiver_groups_delete_confirm_title: 'Delete recipient group',
	mail_receiver_groups_delete_failed: 'Recipient group could not be deleted.',
	mail_receiver_groups_delete_group: 'Delete recipient group',
	mail_receiver_groups_delete_success: 'Recipient group deleted.',
	mail_receiver_groups_delivery_hint:
		'When sending, the selected group is resolved automatically into its email addresses.',
	mail_receiver_groups_empty: 'No recipient groups available.',
	mail_receiver_groups_list_label: 'Recipient groups',
	mail_receiver_groups_load_failed: 'Recipient groups could not be loaded.',
	mail_receiver_groups_loading: 'Loading recipient groups...',
	mail_receiver_groups_member_count: '{count} addresses',
	mail_receiver_groups_members_empty: 'This recipient group does not contain any addresses yet.',
	mail_receiver_groups_members_failed: 'Members could not be loaded.',
	mail_receiver_groups_members_label: 'Members',
	mail_receiver_groups_open_button: 'Groups',
	mail_receiver_groups_open_tooltip: 'Manage recipient groups',
	mail_receiver_groups_remove_member: 'Remove address',
	mail_receiver_groups_remove_member_failed: 'Address could not be removed.',
	mail_receiver_groups_remove_member_success: 'Address removed.',
	mail_receiver_groups_select_hint: 'Select a recipient group to edit its members.',
	mail_receiver_groups_title: 'Recipient groups',
	mail_receiver_groups_validation_group_name_required: 'Please enter a group name.',
	mail_receiver_groups_validation_members_required: 'Please enter at least one valid email address.',
	mail_reply: 'Reply',
	mail_reply_no_access: 'No permission to view the reply',
	mail_reply_status_answered: 'This email was answered',
	mail_replyAll: 'Reply all',
	mail_rules_archive_title: 'hidden addresses',
	mail_rules_auto_delegate_back: 'Back',
	mail_rules_auto_delegate_cancel: 'Cancel',
	mail_rules_auto_delegate_col_creator: 'Creator',
	mail_rules_auto_delegate_col_edit: 'Edit',
	mail_rules_auto_delegate_col_from: 'from',
	mail_rules_auto_delegate_col_mailboxes: 'Mailboxes',
	mail_rules_auto_delegate_col_name: 'Rule Name',
	mail_rules_auto_delegate_col_to: 'to',
	mail_rules_auto_delegate_col_users: 'Users',

	mail_rules_auto_delegate_delete: 'Delete',
	mail_rules_auto_delegate_edit: 'Edit',
	mail_rules_auto_delegate_empty: 'No auto delegate rules available',
	mail_rules_auto_delegate_from: 'from',
	mail_rules_auto_delegate_hidden_info: 'This does',
	mail_rules_auto_delegate_hidden_info_suffix: 'apply to emails from hidden addresses.',
	mail_rules_auto_delegate_hidden_not: 'not',
	mail_rules_auto_delegate_include_hidden: 'include emails from hidden addresses.',
	mail_rules_auto_delegate_mailboxes_legend: 'all emails in the mailboxes',
	mail_rules_auto_delegate_name_error_blank: 'The field must not be empty',
	mail_rules_auto_delegate_name_label: 'Name',
	mail_rules_auto_delegate_name_legend: 'the auto delegation rule with the name',
	mail_rules_auto_delegate_new_rule: 'New Rule',
	mail_rules_auto_delegate_period_legend: 'states that in the time period',
	mail_rules_auto_delegate_save: 'Save',
	mail_rules_auto_delegate_save_error: 'An error occurred while saving.',
	mail_rules_auto_delegate_status_green: 'Green',
	mail_rules_auto_delegate_status_legend: 'The status of the email in my mailbox will then be',
	mail_rules_auto_delegate_status_red: 'Red',
	mail_rules_auto_delegate_status_yellow: 'Yellow',
	mail_rules_auto_delegate_to: 'to',
	mail_rules_auto_delegate_users_legend: 'for the users',
	mail_rules_autodelegate_title: 'Add autodelegation rule',
	mail_rules_blacklist_column_name: 'email address',
	mail_rules_blacklist_empty: 'No addresses on the blacklist',
	mail_rules_blacklist_title: 'Email addresses on the blacklist',
	mail_rules_delete_rule: 'Delete rule',
	mail_rules_dialog_confirm_cancel_label: 'No',
	mail_rules_dialog_confirm_message: 'Do you really want to delete the rule?',
	mail_rules_dialog_confirm_ok_label: 'Yes',
	mail_rules_dialog_confirm_title: 'Delete Rule',
	mail_rules_dialog_title: 'Email rules',
	mail_rules_existing_auto_delegate_title: 'Existing Auto Delegate Rules',
	mail_rules_existing_filter_title: 'Email addresses marked as spam',
	mail_rules_existing_rules_title: 'Existing Spam Rules',
	mail_rules_filter: 'Search...',
	mail_rules_hidden_address: 'address to exclude',
	mail_rules_hidden_col_mailbox: 'Mailbox',
	mail_rules_hidden_col_sender: 'Sender',
	mail_rules_hidden_delete: 'Delete rule',
	mail_rules_hidden_empty: 'No hidden addresses available',
	mail_rules_hidden_mailbox: 'Mailbox',
	mail_rules_hidden_mailbox_all: 'all my email addresses',
	mail_rules_hidden_save: 'Save Rule',
	mail_rules_hidden_title: 'Hide address',
	mail_rules_list_delete: 'Delete Rule',
	mail_rules_list_empty: 'No spam rules available',
	mail_rules_marked_empty: 'No spam-marked addresses found',
	mail_rules_new_rule_condition: 'Spam Rule',
	mail_rules_new_rule_dialog_name: 'Name of the rule',
	mail_rules_new_rule_field_body: 'Body',
	mail_rules_new_rule_field_from: 'From',
	mail_rules_new_rule_field_label: 'Field',
	mail_rules_new_rule_field_subject: 'Subject',
	mail_rules_new_rule_field_to: 'To',
	mail_rules_new_rule_mailbox: 'Mailbox',
	mail_rules_new_rule_mailbox_all: 'All my email addresses',
	mail_rules_new_rule_name: 'Rule',
	mail_rules_new_rule_operator_contains: 'CONTAINS',
	mail_rules_new_rule_operator_ends_with: 'ENDS WITH',
	mail_rules_new_rule_operator_equals: 'EQUALS',
	mail_rules_new_rule_operator_label: 'Operator',
	mail_rules_new_rule_operator_not_contains: 'DOES NOT CONTAIN',
	mail_rules_new_rule_operator_not_ends_with: 'DOES NOT END WITH',
	mail_rules_new_rule_operator_not_starts_with: 'DOES NOT START WITH',
	mail_rules_new_rule_operator_starts_with: 'STARTS WITH',
	mail_rules_new_rule_save: 'Save Rule',
	mail_rules_new_rule_title: 'Define New Spam Rule',
	mail_rules_page_of: "of {'{'}totalPages{'}'}",
	mail_rules_page_report: 'Showing {first} - {last} of {totalRecords}',
	mail_rules_placeholder_coming_soon: 'This feature will be available soon',
	mail_rules_tab_auto_delegate: 'Auto Delegate',
	mail_rules_tab_blacklist: 'Blacklist',
	mail_rules_tab_hidden_addresses: 'Hidden Addresses',
	mail_rules_tab_more: 'More',
	mail_rules_tab_remove_spam: 'Remove Spam Marking',
	mail_rules_tab_rules: 'Spam Rules',
	mail_rules_type_custom_header: 'Confirm with Enter',
	mail_send_as_new: 'Send as new mail',
	mail_show_reply: 'Show reply',
	mail_signatures_badge_default: 'Default',
	mail_signatures_badge_global_template: 'Global Signature',
	mail_signatures_clear_default_popup_title: 'Remove default',
	mail_signatures_col_actions: 'Actions',
	mail_signatures_col_default: 'Default',
	mail_signatures_col_name: 'Name',
	mail_signatures_col_postbox: 'Mailbox',
	mail_signatures_custom_field_caption: 'Placeholder: {{{key}}}',
	mail_signatures_custom_field_placeholder: 'Enter value...',
	mail_signatures_custom_fields_title: 'Custom fields',
	mail_signatures_custom_placeholders_caption:
		'Define custom placeholders for signatures; values can be adjusted per user.',
	mail_signatures_custom_placeholders_default_label: 'Default',
	mail_signatures_custom_placeholders_default_value_label: 'Default value (optional)',
	mail_signatures_custom_placeholders_delete_confirm:
		'Really delete placeholder? All user values will also be deleted.',
	mail_signatures_custom_placeholders_empty_caption: 'Create a new one using the button above.',
	mail_signatures_custom_placeholders_empty_title: 'No custom placeholders yet',
	mail_signatures_custom_placeholders_key_hint:
		'Lowercase letters, digits and _ only. Cannot be changed after creation.',
	mail_signatures_custom_placeholders_key_label: 'Key (e.g. website)',
	mail_signatures_custom_placeholders_key_reserved_error: 'This key is reserved.',
	mail_signatures_custom_placeholders_label_label: 'Label',
	mail_signatures_custom_placeholders_new: 'New Placeholder',
	mail_signatures_custom_placeholders_select_user: 'Select user',
	mail_signatures_custom_placeholders_title: 'Custom Placeholders',
	mail_signatures_custom_placeholders_user_override_title: 'Override user values',
	mail_signatures_delete_confirm_message: 'Are you sure you want to delete this signature?',
	mail_signatures_delete_confirm_title: 'Delete Signature',
	mail_signatures_edit_signature: 'Edit Signature',
	mail_signatures_empty_caption: 'Create your first signature using the button above.',
	mail_signatures_empty_title: 'No Signatures',
	mail_signatures_my_signatures_caption: 'Create your own signatures and set a default per mailbox.',
	mail_signatures_nav_label: 'Signatures',
	mail_signatures_new_signature: 'New Signature',
	mail_signatures_placeholders_label: 'Insert placeholder:',
	mail_signatures_postbox_all: 'All Mailboxes',
	mail_signatures_preview_button_tooltip: 'Show preview',
	mail_signatures_preview_placeholder_hint:
		"Placeholders like {'{{vorname}}'} will be replaced with your own user data when sending.",
	mail_signatures_preview_title: 'Preview of Resolved Placeholders',
	mail_signatures_set_as_default: 'Set as default for this mailbox',
	mail_signatures_set_as_default_all_confirm_message:
		'This action sets the signature as default for all mailboxes and overwrites all existing per-mailbox defaults. Continue?',
	mail_signatures_set_as_default_all_confirm_title: 'Overwrite all mailboxes?',
	mail_signatures_set_as_default_all_mailboxes: 'Set as default for all mailboxes',
	mail_signatures_set_as_default_all_resets_hint:
		'Sets this signature as default for all mailboxes and removes all existing per-mailbox settings.',
	mail_signatures_set_as_default_popup_title: 'Default for',
	mail_signatures_set_as_default_tooltip: 'Set as default',
	mail_signatures_tab_custom_placeholders: 'Placeholders',
	mail_signatures_tab_global_templates: 'Global Signatures',
	mail_signatures_tab_my_signatures: 'My Signatures',
	mail_signatures_tab_user_fields: 'My Placeholders',
	mail_signatures_tab_user_signatures: 'User Signatures',
	mail_signatures_templates_caption: 'Templates available to all users.',
	mail_signatures_templates_col_active: 'Active',
	mail_signatures_templates_col_inactive: 'Inactive',
	mail_signatures_templates_col_name: 'Name',
	mail_signatures_templates_delete_confirm: 'Really delete signature?',
	mail_signatures_templates_empty_caption: 'Create a new one using the button above.',
	mail_signatures_templates_empty_title: 'No global signatures yet',
	mail_signatures_templates_new: 'New Signature',
	mail_signatures_templates_title: 'Global Signatures',
	mail_signatures_user_fields_caption: 'Personal values that fill placeholders in signatures.',
	mail_signatures_user_fields_no_custom_placeholders:
		'No custom placeholders configured yet. An administrator can create new ones in the "Placeholders" tab.',
	mail_signatures_user_fields_saved: 'Saved',
	mail_signatures_user_fields_title: 'Personal Details for Placeholders',
	mail_signatures_user_signatures_caption: 'View and manage signatures of individual users.',
	mail_signatures_user_signatures_empty_title: 'No signatures for this user',
	mail_signatures_user_signatures_pick_user_hint: 'Select a user to manage their signatures.',
	mail_signatures_user_signatures_select_user: 'Select user',
	mail_spam_dialog_confirm_cancel_label: 'No',
	mail_spam_dialog_confirm_message: 'Are you sure you want to spam this email?',
	mail_spam_dialog_confirm_ok_label: 'Yes',
	mail_spam_dialog_confirm_title: 'Mark email as spam?',
	mail_subject: 'Subject',
	mail_to: 'To',
};
